<template>
  <v-card flat>
    <v-toolbar
      color="primary darken-2" 
      dark 
      dense
    >
      <v-toolbar-title class="text-xs-center">Cercas</v-toolbar-title>
      <v-spacer></v-spacer>
      <!-- v-if="!showCreateEditGeofence && role.length !== 1" -->
      <v-btn
        v-if="!showCreateEditGeofence"
        flat 
        icon 
        @click="showCreateGeofencePre">
        <v-icon>
          add
        </v-icon>
      </v-btn>
    </v-toolbar>
    <v-flex v-if="!showCreateEditGeofence">
      <v-flex v-if="$loading.isLoading('fetchingFences')">
        <v-progress-linear :indeterminate="true"/>
      </v-flex>
      <v-flex v-else d-inline-flex pa-2>
        <v-flex>
          <h3>Cercas creadas:</h3>
        </v-flex>
        <v-flex pl-2>
          {{ geofences.length }}
        </v-flex>
      </v-flex>
    </v-flex>
    <!-- LIST OF FENCES -->
    <v-flex v-if="!showCreateEditGeofence">
      <v-flex class="list-items-container">
        <v-list
          v-if="!geoFenceChecking"
          class="scroll-y"
          dense
        >
          <v-list-tile
            v-for="(fence,index) in geofences"
            :key="index"
            :class="highlightFence(fence)"
          >
            <v-list-tile-content>
              <v-list-tile-title v-html="fence.name"/>
              <div class="geofence-id-style">{{ fence.id }}</div>
            </v-list-tile-content>
            <v-list-tile-action>
              <v-btn
                flat
                small
                icon
                @click="handleDisplayFence(fence)"
              >
                <v-icon>visibility</v-icon>
              </v-btn>
            </v-list-tile-action>
            <v-list-tile-action>
              <!-- v-if="role.length !== 1" -->
              <v-btn
                flat
                small
                icon
                :loading="$loading.isLoading('checingkGeoActiveMission')"
                @click="handleEditFence(fence)"
              >
                <v-icon>mode_edit</v-icon>
              </v-btn>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
        <v-flex v-else class="highlight-geofence" pa-2 mx-1>
          <v-icon size="36">layers</v-icon>
          <h3>{{ geoFenceSelected.name }}</h3>
          <div class="geofence-id-style">{{ geoFenceSelected.id }}</div>
          <v-progress-circular
            class="mt-2"
            :size="28"
            width="3"
            color="white"
            indeterminate
          />
          <div class="caption">Procesando datos...</div>
        </v-flex>
      </v-flex>
    </v-flex>
    <!-- CREATE GEOFENCE FORM -->
    <v-flex v-else-if="!editingGeofence">
      <v-flex>
        <v-card>
          <v-flex pa-3>
            <h2>Nueva cerca</h2>
          </v-flex>
          <v-card-text>
            <v-layout column>
              <v-flex>
                <v-text-field
                  v-model="newName"
                  id="name"
                  label="Nombre"
                  box
                  :disabled="isCreatingFence"
                />
              </v-flex>
              <v-flex v-if="adminRole === 400 || adminRole === 500" mt-1>
                <v-select
                  v-model="agencieSelected"
                  :items="agenciesItems"
                  item-text="text"
                  item-value="value"
                  label="Agencia"
                  box
                ></v-select>
              </v-flex>
              <v-flex
                class="d-inline-flex"
                style="justify-items: center"
              >
                <v-btn 
                  color="error"
                  :disabled="isCreatingFence"
                  @click="cancelCreate"
                >
                  Cancelar
                </v-btn>
                <v-btn 
                  color="primary"
                  :disabled="adminRole === 400 || adminRole === 500 ?
                    newName === '' || agencieSelected === null || newPath.length === 0 :
                    newName === '' || newPath.length === 0"
                  :loading="$loading.isLoading('creatingFence')"
                  @click="handleDoneClick"
                >
                  Crear
                </v-btn>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-flex>
    <!-- EDIT GEOFENCE FORM -->
    <v-flex v-if="editingGeofence">
      <!-- EDITING GEOFENCE -->
      <v-card v-if="!checkingDataToUpdateGeofence">
        <v-flex pa-3>
          <h2>Editando cerca</h2>
        </v-flex>
        <v-card-text>
          <v-layout column>
            <v-flex>
              <v-text-field
                v-model="geofenceName"
                id="nameEdit"
                name="name"
                label="Nombre"
                :disabled="isUpdatingFence"
              />
            </v-flex>
            <v-flex class="d-inline-flex" style="justify-items: center">
              <v-btn 
                color="error"
                :disabled="isUpdatingFence"
                @click="cancelEdit"
              >
                Cancelar
              </v-btn>
              <v-btn
                color="primary"
                :disabled="(editedName === '' || editedName === selectedGeofence.name) && editedPath.length === 0"
                :loading="$loading.isLoading('updatingFence')"
                @click="updateGeofence"
              >
                Actualizar
              </v-btn>
            </v-flex>
          </v-layout>
          <p
            v-if="errorMessage!=='' && !isUpdatingFence"
            class="red--text  mt-1 ml-2"
            style="font-weight: bold; font-size: 1rem;"
          >
            {{ errorMessage }}
          </p>
        </v-card-text>
      </v-card>
      <!-- CHECKING DATA TO UPDATE GEOFENCE -->
      <v-card v-else class="mt-3">
        <v-flex class="highlight-geofence" pa-2 mx-1>
          <v-icon size="36">layers</v-icon>
          <h3>{{ geoFenceSelected.name }}</h3>
          <div class="geofence-id-style">{{ geoFenceSelected.id }}</div>
          <v-progress-circular
            class="mt-2"
            :size="28"
            width="3"
            color="white"
            indeterminate
          />
          <div class="caption">Procesando datos...</div>
        </v-flex>
      </v-card>
    </v-flex>
  </v-card>
</template>

<script>
  import {mapActions, mapGetters} from 'vuex'

  import { editGeofenceMixin } from '../../mixins/editGeofenceMixin'

  /**
   * Componente que lista las GeoCercas creadas por los  usuarios de AVL
   * @author Manuel Ochoa
   */
  export default {
    name: 'list-geofences',
    mixins: [editGeofenceMixin],
    props: {
      editedPath: {
        type: Array,
        required: true
      },
      newPath: {
        type: Array,
        required: true
      }
    },
    data() {
      return {
        errorMessage: '',
        // isUpdatingFence: false,
        editedName: '',
        agencieSelected: null,
        // agenciesItems: [],
        isCreatingFence: false,
        /**
         * Array de posiciones que describe un poligono en Google Maps
         * @type {array}
         */
        // newPath: [],
        /**
         * Variable que almacena el nombre de la geocerca
         * @type {string}
         */
        newName: '',
        /**
         * Controla la visibilidad del estado de carga para la creación de la Geocerca
         * @type {boolean}
         */
        loadingDone: false,
        geoFenceSelected: null,
        geoFenceChecking: false,
        checkingDataToUpdateGeofence: false,
        templateSelectedIn: null,
        match: false
      }
    },
    methods: {
      ...mapActions([
        'setGeofenceUpdated',
        'editGeoFence',
        'setEditingGeofence',
        'setGeofenceCreated',
        'selectGeofence',
        'showCreateEditGeofenceAction',
        'createGeofence',
        'checkGeoActiveMission',
        'setMessageGeofence',
        'setShowMessageGeofence',
        'setIsUpdatingFence'
      ]),
      cancelEdit() {
        // console.log('CANCEL EDIT')
        this.showCreateEditGeofenceAction(false)
        this.setIsUpdatingFence(false)
        this.editedName = ''
        this.setEditingGeofence(false)
        this.$emit('cancelEdit')
      },
      async updateGeofence() {
        // console.log('UPDATE GEOFENCE')
        this.checkingDataToUpdateGeofence = true
        const response = await this.checkGeoActiveMission(this.selectedGeofence.id)
        this.checkingDataToUpdateGeofence = false

        if (response !== 'error') {
          if (!response.active) {
            if (response.baseMissionIds.length === 0) { // NORMAL UPDATE
              this.setIsUpdatingFence(true)
              let updateObject = {
                id: this.selectedGeofence.id
              }
              if (this.editedName !== '' && (this.editedName !== this.selectedGeofence.name)) {
                updateObject = {
                  ...updateObject,
                  name: this.editedName
                }
              }
              if (this.editedPath.length > 0) {
                updateObject = {
                  ...updateObject,
                  path: this.editedPath
                }
              }
              const updatedFence = await this.editGeoFence(updateObject)
              if (updatedFence) {
                this.showCreateEditGeofenceAction(false)
                this.setIsUpdatingFence(false)
                this.editedName = ''
                this.setEditingGeofence(false)
              }
            } else { // WARN UPDATE ABOUT BASE MISSION IDS
              const missionNames = []
              const baseMissionIdsLength = response.baseMissionIds.length
              for (let index = 0; index < baseMissionIdsLength; index++) {
                const element = response.baseMissionIds[index]
                this.match = false
                this.templateSelectedIn = null
                this.recursiveSearchM(this.missionsTemplates, element)
                missionNames.push(this.templateSelectedIn.name)
              }
              const payload = {
                title: this.selectedGeofence.name,
                content: `Cualquier cambio que realice en la geocerca ${this.selectedGeofence.name} afectará ${baseMissionIdsLength === 1 ? 'la' : 'las'} ${baseMissionIdsLength === 1 ? 'siguiente' : 'siguientes'} ${baseMissionIdsLength === 1 ? 'misión' : 'misiones'}:`,
                missions: missionNames,
                type: 'related-mission',
                toUpdate: true
              }
              this.setMessageGeofence(payload)
              this.setShowMessageGeofence(true)
            }
          } else { // CAN'T UPDATE GEOFENCE
            const payload = {
              title: this.selectedGeofence.name,
              content: `La geocerca ${this.selectedGeofence.name} hace parte de las zonas que se están utilizando en alguna(s) de las misiones que están activas en este momento. Si desea modificarla, se deben modificar la(s) mision(es) o esperar a que estas finalice(n).`,
              type: 'active-mission',
              toUpdate: true
            }
            this.setMessageGeofence(payload)
            this.setShowMessageGeofence(true)
          }
        }
      },
      cancelCreate() {
        // console.log('CANCEL!!!')
        this.isCreatingFence = false
        this.$emit('cancelCreate')
        this.showCreateEditGeofenceAction(false)
        this.newName = ''
        this.agencieSelected = null
      },
      /**
       * Metodo que crea la GeoCerca con una llamada al action `createGeofence()`
       */
      handleDoneClick() {
        this.isCreatingFence = true
        // console.log('Hi')
        this.$emit('handleDoneClick', { newName: this.newName, agencies: this.agencieSelected })
        // console.log('HOLA')
        // this.newName = ''
        // this.agencieSelected = null
        // this.loadingDone = true
        // this.createGeofence({name: this.newName, path: this.newPath})
        //   .then(fence => {
        //     this.loadingDone = false
        //     // this.$router.back()
        //     this.cancelCreate()
        //   })
      },
      showCreateGeofencePre() {
        this.isCreatingFence = false
        this.$emit('showPolygonTools')
        this.showCreateEditGeofenceAction(true)
      },
      /**
       * Metodo que resalta la GeoCerca seleccionada
       * @param fence
       * @returns {*}
       */
      highlightFence(fence) {
        if (this.selectedGeofence !== null) {
          return {
            'primary': fence.id === this.selectedGeofence.id
          }
        }
        return {}
      },
      /**
       * Metodo que emite un evento que le permite a BaseGeofences.vue, centrar mostrar y centrar el poligono seleccionado
       * @param fence
       */
      handleDisplayFence(fence) {
        this.setEditingGeofence(false)
        this.selectGeofence(fence)
        this.$emit('centerPolygon', fence)
      },
      /**
       * Metodo que entra a la vista de edicion de Geocercas, primero selecciona la cerca en Vuex y luego entra
       * @param fence
       */
      async handleEditFence(fence) {
        this.geoFenceChecking = true
        this.geoFenceSelected = fence
        const response = await this.checkGeoActiveMission(fence.id)

        this.geoFenceChecking = false
        // console.log('handleEditFence RESPONSE', response)
        if (response !== 'error') {
          if (!response.active) {
            if (response.baseMissionIds.length === 0) this.continueToEditFence(fence)
            else {
              const missionNames = []
              const baseMissionIdsLength = response.baseMissionIds.length
              for (let index = 0; index < baseMissionIdsLength; index++) {
                const element = response.baseMissionIds[index]
                this.match = false
                this.templateSelectedIn = null
                this.recursiveSearchM(this.missionsTemplates, element)
                missionNames.push(this.templateSelectedIn.name)
              }
              const payload = {
                title: fence.name,
                content: `Cualquier cambio que realice en la geocerca ${fence.name} afectará ${baseMissionIdsLength === 1 ? 'la' : 'las'} ${baseMissionIdsLength === 1 ? 'siguiente' : 'siguientes'} ${baseMissionIdsLength === 1 ? 'misión' : 'misiones'}:`,
                missions: missionNames,
                type: 'related-mission',
                toUpdate: false
              }
              this.setMessageGeofence(payload)
              this.setShowMessageGeofence(true)
            }
          } else {
            const payload = {
              title: fence.name,
              content: `La geocerca ${fence.name} hace parte de las zonas que se están utilizando en alguna(s) de las misiones que están activas en este momento. Si desea modificarla, se deben modificar la(s) mision(es) o esperar a que estas finalice(n).`,
              type: 'active-mission',
              toUpdate: false
            }
            this.setMessageGeofence(payload)
            this.setShowMessageGeofence(true)
          }
          this.selectGeofence(fence)
        }
      },
      continueToEditFence(fence) {
        this.showCreateEditGeofenceAction(true)
        this.setEditingGeofence(true)
        this.selectGeofence(fence)
        this.$emit('centerPolygon', fence)
      },
      recursiveSearchM(obj, baseMissionId) {
        // console.log('missionsTemplates:', obj)
        for (const children in obj) {
          if (this.match) break

          if (typeof obj[children] === 'object' && obj[children] !== null) {
            if (obj[children].id === baseMissionId) {
              this.templateSelectedIn = obj[children]
              this.match = true
              break
            } else this.recursiveSearchM(obj[children], baseMissionId)
          }
        }
        return this.templateSelectedIn
      }
    },
    // watch: {
    //   agenciesBase(newValue, oldValue) {
    //     // if (newValue.length > 0) {
    //     newValue.forEach(element => {
    //       this.agenciesItems.push({value: element.id, text: element.name})
    //     })
    //     // }
    //   }
    // },
    watch: {
      geofenceUpdated(newValue) {
        if (newValue === 'updated') {
          this.editedName = ''
          this.setGeofenceUpdated('idle')
        } else if (newValue === 'error') {
          this.setIsUpdatingFence(false)
        }
      },
      geofenceCreated(newValue) {
        if (newValue === 'created') {
          this.newName = ''
          this.agencieSelected = null
          this.setGeofenceCreated('idle')
        } else if (newValue === 'error') {
          this.isCreatingFence = false
        }
      }
    },
    computed: {
      ...mapGetters({
        adminRole: 'auth/adminRole',
        geofences: 'getGeofences',
        selectedGeofence: 'getSelectedGeofence',
        role: 'auth/role'
      }),
      ...mapGetters([
        'geofenceUpdated',
        'editingGeofence',
        'geofenceCreated',
        'agenciesBase',
        'showCreateEditGeofence',
        'isUpdatingFence',
        'missionsTemplates'
      ]),
      geofenceName: {
        get() {
          return this.selectedGeofence.name
        },
        set(value) {
          this.editedName = value
        }
      },
      agenciesItems() {
        const result = []
        this.agenciesBase.forEach(element => {
          result.push({value: element.id, text: element.name})
        })
        return result
      }
    }
  }
</script>

<style lang="stylus" scoped>
.list-items-container
  height calc(100vh - 152px)
  overflow-y scroll

.geofence-id-style {
  font-size: 9px;
  margin-top: -6px;
  color: #BDBDBD;
}

.highlight-geofence {
  background-color: #1976D2;
  border-radius: 3px;
}

</style>



// WEBPACK FOOTER //
// src/components/Geofence/ListGeofences.vue